export const config = {
  domain: import.meta.env.PUBLIC_AUTH0_ISSUER_DOMAIN,
  clientId: import.meta.env.AUTH0_M2M_CLIENT_ID,
  clientSecret: import.meta.env.AUTH0_M2M_CLIENT_SECRET,
  cookieName: 'auth0_user_token',
}
